// extracted by mini-css-extract-plugin
export default {"Contact":"Contact_Contact__72QZf","swing-in":"Contact_swing-in__OFWVI"};